/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="14.32"
        viewBox="0 0 19 14.32"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M7.75 0h-5.7v1.73H0v12.59h17.27v-2.06H19V1.56H8.87Zm8.52 13.32H1V2.73h1.06v9.53h14.21ZM18 11.26H3.06V4.9H18Zm0-7.36H3.06V1h4.18l1.11 1.56H18Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'TwoFoldersIcon';

export default Icon;
